import {
  Box,
  Flex,
  HStack,
  Link,
  Container,
  useColorModeValue,
} from '@chakra-ui/react';
import { ColorModeSwitcher } from '../../ColorModeSwitcher';
import { Logo } from '../../Logo';

const navLinks = [
  { label: 'Services', href: '#services' },
  { label: 'Solutions', href: '#solutions' },
  { label: 'Case Studies', href: '#case-studies' },
  { label: 'Contact', href: '#contact' },
];

export const Navbar = () => {
  const bg = useColorModeValue('white', 'gray.900');
  const borderColor = useColorModeValue('gray.100', 'gray.700');
  const navBg = useColorModeValue(
    'rgba(255, 255, 255, 0.9)',
    'rgba(23, 25, 35, 0.9)'
  );
  const linkColor = useColorModeValue('gray.600', 'gray.300');
  const linkHoverColor = useColorModeValue('brand.500', 'brand.300');

  const handleSmoothScroll = (
    e: React.MouseEvent<HTMLAnchorElement>,
    href: string
  ) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Box
      as="nav"
      position="fixed"
      top={0}
      left={0}
      right={0}
      zIndex={1000}
      bg={bg}
      borderBottom="1px"
      borderColor={borderColor}
      backdropFilter="blur(10px)"
      backgroundColor={navBg}
    >
      <Container maxW="container.xl">
        <Flex h={16} alignItems="center" justifyContent="space-between">
          <Link
            href="#"
            onClick={(e) => handleSmoothScroll(e, '#hero')}
            _hover={{ textDecoration: 'none' }}
          >
            <Logo h="40px" />
          </Link>

          <HStack spacing={8}>
            <HStack as="nav" spacing={6} display={{ base: 'none', md: 'flex' }}>
              {navLinks.map((link) => (
                <Link
                  key={link.href}
                  href={link.href}
                  onClick={(e) => handleSmoothScroll(e, link.href)}
                  fontWeight="medium"
                  color={linkColor}
                  _hover={{
                    color: linkHoverColor,
                  }}
                >
                  {link.label}
                </Link>
              ))}
            </HStack>
            <ColorModeSwitcher />
          </HStack>
        </Flex>
      </Container>
    </Box>
  );
};
